module.exports = __webpack_public_path__ + "img/like-red.3db20f60.svg";